<template>
  <div class="login login_common">
    <nav-top :nav-type="3"/>
    <div class="section flex_column_center">
      <img class="logo_1" src="@/assets/icon/logo.png"/>
      <el-form ref="form" :model="form" :rules="rules" class="form">
        <el-form-item prop="userId">
          <el-input v-model="form.userId" type="text" placeholder="아이디 (이메일 주소)" @keyup.native="handleInput" @blur="handleInputBlur"/>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" type="password" placeholder="비밀번호" maxlength="20" @keyup.native="handleInput" @blur="handleInputBlur"/>
        </el-form-item>
        <el-checkbox v-model="storeLogin">자동 로그인</el-checkbox>
        <el-button v-waves :disabled="!loginBtnOn" class="btn_big" @click="handleLogin">로그인</el-button>
      </el-form>
      <div class="link_box flex_between">
        <router-link class="btn_link flex_row_center" to="/findaccount">
          <p class="btn_content">아이디/비밀번호 찾기</p><img class="arrow_light" src="@/assets/icon/arrow.png"/>
        </router-link>
        <router-link class="btn_link flex_row_center" to="/signup">
          <p class="btn_content">회원가입</p><img class="arrow_light" src="@/assets/icon/arrow.png"/>
        </router-link>
      </div>
      <div class="easy_login flex_column_center">
        <p class="h3">간편 로그인</p>
        <div class="easy_group flex_around">
          <div class="flex_column_center" @click="handleFacebookLogin">
            <img class="icon-normal" src="@/assets/icon/icon_facebook.png"/>
            <p class="name">페이스북</p>
          </div>
          <div class="flex_column_center" @click="handleKakaoLogin">
            <img class="icon-normal" src="@/assets/icon/icon_katalk.png"/>
            <p class="name">카카오톡</p>
          </div>
          <div class="flex_column_center" @click="handleNaverLogin">
            <img class="icon-normal" src="@/assets/icon/icon_naver.png"/>
            <p>네이버</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NavTop from '@/components/navTop'
  import waves from '@/directive/waves'

  import { login, getUserInfo } from '@/http/api/account'
  import { contextRemoveIntroView, contextKakaoLogin, contextNaverLogin, contextFacebookLogin, contextSaveData } from '@/hybrid'

  let app = null;

  export default {
    name: 'Login',
    directives: { waves },
    components: { NavTop },
    data () {
      return {
        httpTimestamp: 0,
        form: {
          userId: '',
          password: ''
        },
        rules: {
          userId: [
            { required: true, message: '아이디를 입력해주세요.', trigger: 'blur' },
            { pattern: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, message: '아이디를 이메일 형식으로 입력해주세요.', trigger: 'blur' }
          ],
          password: [{ required: true, message: '비밀번호를 입력해주세요.', trigger: 'blur' }]
        },
        storeLogin: false, // 아이디 저장 여부
        loginBtnOn: false // 로그인 버튼 활성화 여부
      }
    },
    created () {
      app = this

      if (process.env.HYBRID) {
        this.$showCustomLoading()
      }
    },
    mounted () {
      contextRemoveIntroView()
    },
    methods: {
      handleLogin () {
        this.httpTimestamp = (new Date).getTime()
        this.$showCustomLoading()

        login(this.form.userId, this.form.password).then(tokenResponse => {
          getUserInfo(tokenResponse.accessToken).then(userResponse => {
            setTimeout(function() {
              app.$dismissCustomLoading()

              contextSaveData('accessToken', tokenResponse.accessToken)
              if (app.storeLogin) {
                contextSaveData('loginType', 'A')
              } else {
                contextSaveData('loginType', '')
              }

              app.$store.dispatch('setToken', tokenResponse.accessToken)
              app.$store.dispatch('setId', userResponse.id)
              app.$store.dispatch('setName', userResponse.name)
              app.$store.dispatch('setUsername', userResponse.username)

              app.$router.push({ name: 'index' })
            }, 1000 - ((new Date).getTime() - this.httpTimestamp))

            // console.log(this.$store.getters.token)
            // console.log(this.$store.getters.id)
            // console.log(this.$store.getters.name)
            // console.log(this.$store.getters.username)
          }).catch(function(error) {
            setTimeout(function() {
              app.$dismissCustomLoading()
            }, 1000 - ((new Date).getTime() - app.httpTimestamp))
          })
        }).catch(function(error) {
          setTimeout(function() {
            app.$dismissCustomLoading()

            app.$customAlert({
              message: error.response.data.message
            })
          }, 1000 - ((new Date).getTime() - app.httpTimestamp))
        })
      },
      handleKakaoLogin () {
        contextKakaoLogin()
      },
      handleNaverLogin () {
        contextNaverLogin()
      },
      handleFacebookLogin () {
        contextFacebookLogin()
      },
      handleInput () {
        if (this.form.userId !== '' && this.form.password !== '') {
          this.loginBtnOn = true
        } else {
          this.loginBtnOn = false
        }
      },
      // iOS에서 키보드가 보이고 내려갈 시에 webView의 렌더링이 깨지는것을 trick으로 복구
      handleInputBlur () {
        document.body.scrollTop = document.body.scrollTop
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Account/Login.vue